module.exports = __webpack_public_path__ + "img/GENIKES_256x256_72dpi.6275ed45.png";